import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Auth, I18n } from 'aws-amplify'
import { useAlert } from 'react-alert'

import { settings } from '../../../../main/configs/settings'

import { useForm } from '../../../hooks'
import { exceptionsError } from '../../../utils'
import { Button, Input, InputPassword } from '../../../components'
import { CardContainer } from '../../../components/ui/components'

import { ArrowRightSvg, FullLogoSvg } from '../../../assets/icons/svgComponents'

import { PasswordRequirements } from '../signup/styles'
import * as S from './styles'

const RecoverPassword = () => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const alert = useAlert()
  const email = useForm('email')
  const code = useForm()
  const password = useForm('password')
  const confirmPassword = useForm('confirmPassword')

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      setLoading(true)
      await Auth.forgotPasswordSubmit(email.value, code.value, password.value)
      alert.show(I18n.get('PasswordUpdatedSuccess'), {
        type: 'success',
        timeout: 4000
      })

      history.replace(settings.dashboardRoute)
    } catch (error: any) {
      alert.show(exceptionsError(error.code, error.message), {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <S.Wrapper>
      <CardContainer style="container">
        <S.Content>
          <FullLogoSvg
            colorX="#00995D"
            colorLetters="#6F6F6E"
            width="182"
            height="42"
          />
          <S.Subtitle>Seja bem-vindo(a)!</S.Subtitle>
          <S.Description>Coloque sua nova senha.</S.Description>
          <form onSubmit={onSubmit}>
            <Input
              onKeyUp={() => email.validate()}
              labelColor="#4F4F4F"
              label="E-mail"
              type="email"
              name="email"
              {...email}
            />
            <Input
              labelColor="#4F4F4F"
              label="Código"
              type="number"
              name="code"
              {...code}
            />
            <InputPassword
              labelColor="#4F4F4F"
              label="Senha"
              name="password"
              topEyer="37px"
              topEyerBlock="35px"
              {...password}
            />
            <InputPassword
              onKeyUp={() => confirmPassword.validate()}
              labelColor="#4F4F4F"
              label="Confirmar senha"
              name="confirmPassword"
              topEyer="37px"
              topEyerBlock="35px"
              {...confirmPassword}
            />
            <PasswordRequirements>
              Precisa no mínimo 8 digitos
            </PasswordRequirements>
            <PasswordRequirements>
              Precisa conter um caractere especial */+.s
            </PasswordRequirements>
            <PasswordRequirements>
              Precisa conter uma letra em MAIÚSCULA
            </PasswordRequirements>
            <S.ButtonContainer>
              {loading ? (
                <Button
                  disabled
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Confirmando...
                </Button>
              ) : (
                <Button
                  disabled={
                    confirmPassword.error ||
                    password.error ||
                    !password.value ||
                    !confirmPassword.value
                  }
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Confirmar
                </Button>
              )}
            </S.ButtonContainer>
          </form>
        </S.Content>
      </CardContainer>
    </S.Wrapper>
  )
}
export default RecoverPassword
